'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.isCloseModalAction = exports.openModal = exports.isOpenModalAction = undefined;

var _constants = require('./constants');

/**
 * Checks if the passed action is of type OPEN_MODAL
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to OPEN_MODAL. False otherwise.
 */
var isOpenModalAction = exports.isOpenModalAction = function isOpenModalAction(action) {
  return action.type === _constants.OPEN_MODAL;
};

/**
 * Open modal
 * @param {string} activeModalName Modal name
 * @returns {Object} The action to be dispatched
 */
var openModal = exports.openModal = function openModal(activeModalName) {
  return {
    type: _constants.OPEN_MODAL,
    activeModalName: activeModalName
  };
};

/**
 * Checks if the passed action is of type CLOSE_MODAL
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to CLOSE_MODAL. False otherwise.
 */
var isCloseModalAction = exports.isCloseModalAction = function isCloseModalAction(action) {
  return action.type === _constants.CLOSE_MODAL;
};

/**
 * Close modal
 * @returns {Object} The action to be dispatched
 */
var closeModal = exports.closeModal = function closeModal() {
  return {
    type: _constants.CLOSE_MODAL
  };
};
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/actions.js
// module id = 176
// module chunks = 0